import React, { useEffect, useState } from "react";
import { Button } from "evergreen-ui";
import AssociatedFile from "./ProfileTab/AssociatedFile";
import BankDetails from "./ProfileTab/BankDetails";
import BasicProfile from "./ProfileTab/BasicProfile";
import ContactInfo from "./ProfileTab/ContactInfo";
import "./profile.css";
import Header from "../Header/Header";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { ModalComp } from "../PO/Modal/ModalComp";
import { ModalChangePassword } from "./ModalChangePassword";
import { validatePhoneNumber } from "../../Utils/Validation";
import { PRODUCT } from "../../Utils/variables";
const Profile = () => {
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const [checkLOading, setcheckLOading] = useState(false);
  const [forRender, setforRender] = useState(true);
  const { vendorId,userId } = useSelector((state) => state.auth);
  const [profileData, setprofileData] = useState({
    tradeLicenseNumber: "",
    licenseIssueDate: "",
    licenseExpiryDate: "",
    typeOfProduct: [],
    country: "",
    taxRegistrationNumber: "",
    bankDetails: "",
    accountNumber: "",
    IBANnumber: "",
    SWIFTcode: "",
    contactPerson: "",
    email: "",
    contactNumber: "",
    tradeLicense: "",
    taxRegistrationCertificate: "",
    vendorLogo: "",
    vendor_category_selected: [],
    documents: [],
    vendor_name: "",
    user_id: "",
  });
  const [doc, setDoc] = useState([
    {
      unique: "vendorLogo",
    },

    {
      unique: "tradeLicense",
    },
    {
      unique: "taxReg",
    },
  ]);

  const loadProfileDetail = () => {
    fetch(process.env.REACT_APP_API_URL + "/api/vendor/show", {
      method: "POST",
      body: JSON.stringify({ vendor_id: vendorId }),
      headers: { "content-type": "application/json" },
    })
      .then((d) => d.json())
      .then((res) => {
        let data = res.response[0];

        setprofileData({
          tradeLicenseNumber: data.trade_license_number,
          licenseIssueDate: data.trade_license_issue_date,
          licenseExpiryDate: data.trade_license_exp_date,
          typeOfProduct: data.vendor_category,
          country: data.country_id,
          countryName: data.country,
          taxRegistrationNumber: data.gstin_number,
          bankDetails: data.bank_name,
          accountNumber: data.account_number,
          IBANnumber: data.iban_number,
          SWIFTcode: data.swift_code,
          contactPerson: data.contact_person_name,
          email: data.vendor_email,
          contactNumber: data.vendor_phone,
          tradeLicense: "",
          taxRegistrationCertificate: "",
          vendorLogo: "",
          vendor_category_id: data.vendor_category_id,
          vendor_category_selected: data.vendor_category_selected,
          inserted_by: data.inserted_by,
          vendor_name: data.vendor_name,
          user_id: data.user_id,
        });

        let downloadData = data.documents;
        let newData = [];

        for (
          let i = 0;
          downloadData.length < 3 ? i < downloadData.length : i < 3;
          i++
        ) {
          newData.push(downloadData[i]);
        }
        setDoc(newData);
        localStorage.setItem("profile_documents", JSON.stringify(newData));
      })
      .catch((err) => console.log("e", err));
  };
  const handleProfileUpdate = () => {
    setcheckLOading(true);
    const newDoc = profileData?.documents?.filter((e) => e.url !== "");
    const uniqDoc = newDoc
      ? [...doc].filter(
          ({ unique: id1 }) => !newDoc.some(({ unique: id2 }) => id2 === id1)
        )
      : doc;

    const actualDoc =
      newDoc && uniqDoc
        ? [...uniqDoc, ...newDoc]
        : newDoc
        ? [...newDoc]
        : [...uniqDoc];

    let payload = {
      vendor_id: vendorId,
      trade_license_number: profileData.tradeLicenseNumber,
      trade_license_issue_date: profileData.licenseIssueDate,
      trade_license_exp_date: profileData.licenseExpiryDate,
      vendor_category_id: profileData.vendor_category_id,
      country: profileData.country,
      gstin_number: profileData.taxRegistrationNumber,
      bank_name: profileData.bankDetails,
      bank_account_number: profileData.accountNumber,
      iban_number: profileData.IBANnumber,
      swift_code: profileData.SWIFTcode,
      contact_person_name: profileData.contactPerson,
      email: profileData.email,
      contact_number: profileData.contactNumber,
      documents: actualDoc,
      inserted_by: profileData.inserted_by,
      vendor_name: profileData.vendor_name,
    };
    if (!validatePhoneNumber(profileData.contactNumber, profileData.country)) {
      toast.error("Please enter valid Contact Number");
      loadProfileDetail();
    } else if (profileData.licenseIssueDate == "") {
      toast.error("License Issue Date is required");
      loadProfileDetail();
    } else if (profileData.licenseExpiryDate == "") {
      toast.error("License Expiry Date is required");
      loadProfileDetail();
    } else if (profileData.contactPerson == "") {
      toast.error("Name field is required");
      loadProfileDetail();
    } else {
      fetch(process.env.REACT_APP_API_URL + "/api/vendor/update", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: { "content-type": "application/json" },
      })
        .then((d) => d.json())
        .then((res) => {
          setcheckLOading(false);

          if (res.status === true) {
            toast(`${res.message}`, {
              type: "success",
            });
            // loadProfileDetail();
            setTimeout(() => {
              setforRender(!forRender);
            }, 3000);
          } else {
            toast(`${res.message}`, {
              type: "error",
            });
          }
        })
        .catch((err) => console.log("e", err));

      // setforRender(!forRender);
    }
  };

  const RenderingFunc = () => {
    setforRender(!forRender);
  };
  useEffect(() => {
    loadProfileDetail();
    document.title = PRODUCT + " - Profile";
  }, [forRender]);

  return (
    <div className="routingSubContainer">
      <Header
        title={"Profile"}
        changePasswordBtn={true}
        onOpenModal={onOpenModal}
      />
      <ModalChangePassword
        open={open}
        onOpenModal={onOpenModal}
        onCloseModal={onCloseModal}
        userId={userId}
      />
      <div className="phHeadMain">
        <BasicProfile
          allData={profileData}
          setAllData={setprofileData}
          handleProfileUpdate={handleProfileUpdate}
          RenderingFunc={RenderingFunc}
          loading={checkLOading}
        />
        <BankDetails
          allData={profileData}
          setAllData={setprofileData}
          handleProfileUpdate={handleProfileUpdate}
          loading={checkLOading}
        />
        <ContactInfo
          allData={profileData}
          setAllData={setprofileData}
          handleProfileUpdate={handleProfileUpdate}
          loading={checkLOading}
        />
        <AssociatedFile
          allData={profileData}
          setAllData={setprofileData}
          handleProfileUpdate={handleProfileUpdate}
          doc={doc}
          loading={checkLOading}
        />
      </div>
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default Profile;
